import { useState, useEffect } from 'react';
import { useApiClientsOrNull } from '../context/ApiClientsContext';

const SYSTEM_TENANT_ID = '00000000-0000-0000-0000-000000000000';

export interface UsePublisherNameResult {
  publisherName: string;
  isSystem: boolean;
  loading: boolean;
}

export function usePublisherName(tenantId: string | null | undefined): UsePublisherNameResult {
  const apiClients = useApiClientsOrNull();

  const [publisherName, setPublisherName] = useState('');
  const [isSystem, setIsSystem] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!tenantId) {
      setPublisherName('');
      setIsSystem(false);
      setLoading(false);
      return;
    }

    if (tenantId === SYSTEM_TENANT_ID) {
      setPublisherName('Center Platform');
      setIsSystem(true);
      setLoading(false);
      return;
    }

    if (!apiClients?.organizationClient) {
      return;
    }

    let cancelled = false;

    const fetchPublisher = async () => {
      setLoading(true);

      try {
        const response = await apiClients.organizationClient.get(
          `/organizations/${tenantId}`
        );

        if (!cancelled) {
          const name = response?.data?.name || response?.name;
          setPublisherName(name || tenantId.substring(0, 8));
          setIsSystem(false);
        }
      } catch {
        if (!cancelled) {
          setPublisherName(tenantId.substring(0, 8));
          setIsSystem(false);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchPublisher();

    return () => {
      cancelled = true;
    };
  }, [tenantId, apiClients]);

  return { publisherName, isSystem, loading };
}
